/* eslint-disable no-param-reassign, react/prop-types */
import { DreamBlock } from '@typedream/core';
import {
  getBlockAbove,
  isCollapsed,
} from '@udecode/plate-core';
import { isEqual } from 'lodash';
import {
  Operation, Path, Point, Range,
} from 'slate';
import {
  DreamWithOverride,
  ElementPluginOptions,
  getTElementPlugins,
} from '../../plate';
import { selectElement } from './transforms';

export const withElementSelection: DreamWithOverride = (editor) => {
  const { apply, store } = editor;

  const { setState, getState } = store;

  editor.apply = (op) => {
    apply(op);

    const currentElementSelections = getState().selectedElementPaths;
    const nextElementSelections = currentElementSelections
      .map((p) => Path.transform(p, op as Operation))
      .filter(Boolean) as Path[];

    if (!isEqual(currentElementSelections, nextElementSelections)) {
      setState({ selectedElementPaths: nextElementSelections });
    }

    // When clicking into the editor for the first time
    const isSelectingEditorForTheFirstTime = (
      op.type === 'set_selection'
      && Point.isPoint(op.newProperties?.anchor)
      && Point.isPoint(op.newProperties?.focus)
      && isCollapsed(op.newProperties as Range)
      && currentElementSelections.length === 0
    );

    // When selecting a text not inside current element selection.
    // This happens when navigating using arrow keys
    const isSelectingTextNotInsideCurrentElementSelection = (
      op.type === 'set_selection'
      && Point.isPoint(op.newProperties?.anchor)
      && Point.isPoint(op.newProperties?.focus)
      && isCollapsed(op.newProperties as Range)
      && currentElementSelections.length === 1
      && !Path.isAncestor(
        currentElementSelections[0],
        (op.newProperties as Range).focus.path,
      )
    );

    // When selecting a text not inside current element selection.
    // This happens when navigating using arrow keys
    if (
      isSelectingEditorForTheFirstTime
      || isSelectingTextNotInsideCurrentElementSelection
    ) {
      const selectableElementTypes = getTElementPlugins(editor)
        .filter(
          (p) => p.isElement && (p.options as ElementPluginOptions)?.isSelectable,
        )
        .map((p) => p.type);

      const path = getBlockAbove(editor, {
        match: (n: DreamBlock) => selectableElementTypes.includes(n.type),
        at: op.newProperties as Range,
      })?.[1];

      if (path) {
        selectElement(editor, path);
      }
    }
  };

  return editor;
};
